import React, { useContext } from 'react';

const AppContext = React.createContext({
    withEnglishBAL: false,
    isTiktokShopActive: false,
});

export const useAppContext = () => useContext(AppContext);

export default AppContext;
